// ** Components
import SearchSection from '@/components/common/searchSection';

type SearchFilterOption = {
	value: string;
	label: string | null;
};

type SearchFilterConfig = {
	searchFilterShowCategory?: boolean;
	searchFilterShowPeriod?: boolean;
	searchFilterShowSearch?: boolean;
	searchFilterCategoryPlaceholder?: string;
	searchFilterPeriodPlaceholder?: string;
	searchFilterSearchPlaceholder?: string;
	categoryPlaceholder?: string;
	periodPlaceholder?: string;
	searchPlaceholder?: string;
	showCategory?: boolean;
	showPeriod?: boolean;
	showSearch?: boolean;
};

type SearchFilterOptions = {
	categoryOptions?: SearchFilterOption[];
	categories?: SearchFilterOption[];
	periodOptions?: SearchFilterOption[];
	periods?: SearchFilterOption[];
};

type SearchFilterState = {
	selectedCategory?: string | null;
	selectedPeriod?: string | null;
	searchTerm?: string;
};

type SearchFilterHandlers = {
	onCategoryChange?: (value: string | null) => void;
	onPeriodChange?: (value: string | null) => void;
	onSearchChange?: (value: string) => void;
	onSearchSubmit?: (value: string) => void;
};

type ComponentBlocksSearchFilterProps = {
	config?: SearchFilterConfig;
	options?: SearchFilterOptions;
	state?: SearchFilterState;
	handlers?: SearchFilterHandlers;
	backgroundColor?: string;
};

const ComponentBlocksSearchFilter = ({
	config,
	options,
	state,
	handlers,
	backgroundColor
}: ComponentBlocksSearchFilterProps) => {
	const isVisible =
		config?.searchFilterShowCategory || config?.searchFilterShowPeriod || config?.searchFilterShowSearch;

	if (!isVisible) return null;

	const rawCategories = options?.categoryOptions || options?.categories || [];
	const rawPeriods = options?.periodOptions || options?.periods || [];

	// Map options to ensure `label` is always a `string`
	const formattedCategories = rawCategories.map((opt) => ({
		value: opt.value,
		label: opt.label ?? ''
	}));

	const formattedPeriods = rawPeriods.map((opt) => ({
		value: opt.value,
		label: opt.label ?? ''
	}));

	return (
		<SearchSection
			categoryOptions={formattedCategories}
			periodOptions={formattedPeriods}
			selectedCategory={state?.selectedCategory ?? ''}
			selectedPeriod={state?.selectedPeriod ?? ''}
			searchTerm={state?.searchTerm ?? ''}
			categoryPlaceholder={config?.searchFilterCategoryPlaceholder ?? config?.categoryPlaceholder ?? 'Kategorie'}
			periodPlaceholder={config?.searchFilterPeriodPlaceholder ?? config?.periodPlaceholder ?? 'Zeitraum'}
			searchPlaceholder={config?.searchFilterSearchPlaceholder ?? config?.searchPlaceholder ?? 'Suchen...'}
			backgroundColor={backgroundColor}
			onCategoryChange={handlers?.onCategoryChange ?? (() => undefined)}
			onPeriodChange={handlers?.onPeriodChange ?? (() => undefined)}
			onSearchChange={handlers?.onSearchChange ?? (() => undefined)}
			onSearchSubmit={handlers?.onSearchSubmit ?? (() => undefined)}
			showCategory={config?.searchFilterShowCategory ?? config?.showCategory ?? true}
			showPeriod={config?.searchFilterShowPeriod ?? config?.showPeriod ?? true}
			showSearch={config?.searchFilterShowSearch ?? config?.showSearch ?? true}
		/>
	);
};

export default ComponentBlocksSearchFilter;
